<template>
  <div class="text-[12px] flex items-start justify-start mt-[44px]">
    <a-checkbox
      class="mt-[4px]"
      :checked="checked"
      @change="onChange"
    ></a-checkbox>
    <div class="ml-[5px] mt-[3px] text">
      {{ $t('wo-yi-yue-du-bing-tong-yi') }}
      <Purchase />
      <template v-if="buyType === BUY_TYPE.SUBSCRIBE">
        、<Subscription />
      </template>
      <template v-if="area === 'CN'"> {{ $t('he') }} <CreditCoin /> </template>
    </div>
  </div>
</template>

<script setup lang="ts" name="PayAgreement">
import { BUY_TYPE } from '~/api/interface'
import {
  User,
  CreditCoin,
  Purchase,
  Subscription,
} from '~/components/protocols'

defineProps<{ checked: boolean; buyType: BUY_TYPE }>()

const runtimeConfig = useRuntimeConfig()
const area = runtimeConfig.public.area

const emits = defineEmits(['checked'])

function onChange(e: any) {
  emits('checked', e.target.checked)
}
</script>

<style lang="scss" scoped>
.text {
  color: var(--text-1-60);
}
:deep(a) {
  color: var(--text-1);
  &:hover {
    color: var(--primary-color);
  }
}
</style>
